export type TextVariant = 'header' | 'body' | 'muted' | 'section' | 'code';

export type ModalTheme = {
    fonts: Record<TextVariant | 'button', string>;
    lineHeights: Record<TextVariant, number>;
    colors: {
        frameFill: string;
        frameStroke: string;
        headerText: string;
        bodyText: string;
        mutedText: string;
        sectionText: string;
        codeText: string;
        closeStroke: string;
        buttonFill: string;
        buttonFillDisabled: string;
        buttonStroke: string;
        buttonStrokeDisabled: string;
        buttonText: string;
        buttonTextDisabled: string;
        tabActiveFill: string;
        tabInactiveFill: string;
        tabActiveText: string;
        tabInactiveText: string;
        tabStroke: string;
        barBad: string;
        barGood: string;
        barWarn: string;
        costGood: string;
        costBad: string;
        houseTileFill: string;
        houseTileStroke: string;
        houseTileSelectedStroke: string;
        houseTileWarnFill: string;
    };
    spacing: {
        itemGap: number;
        sectionGap: number;
    };
    button: {
        height: number;
        textOffsetY: number;
        minWidth: number;
    };
    tabs: {
        height: number;
        paddingX: number;
        textOffsetY: number;
        gap: number;
    };
    progress: {
        height: number;
        gap: number;
        trackFill: string;
        trackStroke: string;
        fill: string;
    };
    storageGrid: {
        columns: number;
        gap: number;
        padding: number;
        iconSize: number;
    };
    buildingGrid: {
        columns: number;
        gap: number;
        padding: number;
        buttonHeight: number;
    };
    productionGrid: {
        columns: number;
        gap: number;
        padding: number;
        cellHeight: number;
        barHeight: number;
        iconSize: number;
    };
    houseGrid: {
        columns: number;
        gap: number;
        padding: number;
        cellHeight: number;
    };
    peopleList: {
        rowHeight: number;
        gap: number;
        padding: number;
        barHeight: number;
    };
    costTooltip: {
        columns: number;
        rows: number;
        cellW: number;
        cellH: number;
        gap: number;
        padding: number;
        iconSize: number;
    };
};

export const DEFAULT_MODAL_THEME: ModalTheme = {
    fonts: {
        header: '16px monospace',
        body: '13px monospace',
        muted: '12px monospace',
        section: '13px monospace',
        code: '12px monospace',
        button: '13px monospace',
    },
    lineHeights: {
        header: 18,
        body: 16,
        muted: 14,
        section: 16,
        code: 14,
    },
    colors: {
        frameFill: 'rgba(12,12,14,0.88)',
        frameStroke: 'rgba(255,255,255,0.15)',
        headerText: '#ffffff',
        bodyText: '#e5e5e5',
        mutedText: '#b0b0b0',
        sectionText: '#e5e5e5',
        codeText: '#cfd8dc',
        closeStroke: 'rgba(255,255,255,0.4)',
        buttonFill: 'rgba(58,110,78,0.75)',
        buttonFillDisabled: 'rgba(60,60,60,0.45)',
        buttonStroke: 'rgba(255,255,255,0.35)',
        buttonStrokeDisabled: 'rgba(255,255,255,0.15)',
        buttonText: '#e9f5ee',
        buttonTextDisabled: '#b0b0b0',
        tabActiveFill: 'rgba(58,110,78,0.8)',
        tabInactiveFill: 'rgba(30,30,32,0.85)',
        tabActiveText: '#e9f5ee',
        tabInactiveText: '#eaeaea',
        tabStroke: 'rgba(255,255,255,0.2)',
        barBad: '#db2d42',
        barGood: '#64d96b',
        barWarn: '#f2a04f',
        costGood: '#64d96b',
        costBad: '#e05a5a',
        houseTileFill: 'rgba(26,28,30,0.9)',
        houseTileStroke: 'rgba(255,255,255,0.2)',
        houseTileSelectedStroke: '#64d96b',
        houseTileWarnFill: 'rgba(255,170,80,0.5)',
    },
    spacing: {
        itemGap: 6,
        sectionGap: 6,
    },
    button: {
        height: 22,
        textOffsetY: 4,
        minWidth: 26,
    },
    tabs: {
        height: 22,
        paddingX: 10,
        textOffsetY: 4,
        gap: 6,
    },
    progress: {
        height: 8,
        gap: 4,
        trackFill: 'rgba(30,30,32,0.6)',
        trackStroke: 'rgba(255,255,255,0.15)',
        fill: 'rgba(88,196,122,0.75)',
    },
    storageGrid: {
        columns: 3,
        gap: 6,
        padding: 6,
        iconSize: 16,
    },
    buildingGrid: {
        columns: 3,
        gap: 8,
        padding: 6,
        buttonHeight: 20,
    },
    productionGrid: {
        columns: 2,
        gap: 8,
        padding: 6,
        cellHeight: 88,
        barHeight: 6,
        iconSize: 14,
    },
    houseGrid: {
        columns: 3,
        gap: 8,
        padding: 6,
        cellHeight: 92,
    },
    peopleList: {
        rowHeight: 96,
        gap: 6,
        padding: 6,
        barHeight: 6,
    },
    costTooltip: {
        columns: 8,
        rows: 2,
        cellW: 52,
        cellH: 24,
        gap: 4,
        padding: 6,
        iconSize: 16,
    },
};
